import { gql } from '@apollo/client';

const CREATE_PRODUCT_VARIANT = gql`
  mutation createProductVariant($productVariant: ProductVariantCreateInput!) {
    createProductVariant(productVariant: $productVariant) {
      success
      message
      productVariant {
        id
        title
        description
        price
        img
      }
    }
  }
`;

const UPDATE_PRODUCT_VARIANT = gql`
  mutation updateProductVariant($id: ID!, $productVariant: ProductVariantUpdateInput!) {
    updateProductVariant(id: $id, productVariant: $productVariant) {
      success
      message
      productVariant {
        id
      }
    }
  }
`;

const DELETE_PRODUCT_VARIANT = gql`
  mutation deleteProductVariant($id: ID!) {
    deleteProductVariant(id: $id) {
      success
      message
      productVariant {
        id
      }
    }
  }
`;

const CHANGE_PRIMARY_VARIANT = gql`
  mutation changePrimaryVariant($id: ID!, $product: ID!) {
    changePrimaryVariant(id: $id, product: $product) {
      success
      message
      productVariant {
        id
      }
    }
  }
`;

export {
  CREATE_PRODUCT_VARIANT,
  UPDATE_PRODUCT_VARIANT,
  DELETE_PRODUCT_VARIANT,
  CHANGE_PRIMARY_VARIANT,
}
